var map = {
	"./comics-1/desktop/frame-10/bubbles.png": 7247,
	"./comics-1/desktop/frame-11/bubbles.png": 45694,
	"./comics-1/desktop/frame-12/bubbles.png": 64740,
	"./comics-1/desktop/frame-13/bubbles.png": 35229,
	"./comics-1/desktop/frame-14/bubbles.png": 13443,
	"./comics-1/desktop/frame-4/bubbles.png": 58040,
	"./comics-1/desktop/frame-5/bubbles.png": 44934,
	"./comics-1/desktop/frame-6/bubbles.png": 17581,
	"./comics-1/desktop/frame-7/bubbles.png": 48649,
	"./comics-1/desktop/frame-8/bubbles.png": 88886,
	"./comics-1/desktop/frame-9/bubbles.png": 24769,
	"./comics-1/mobile/frame-10/bubbles.png": 35350,
	"./comics-1/mobile/frame-11/bubbles.png": 56415,
	"./comics-1/mobile/frame-12/bubbles.png": 86501,
	"./comics-1/mobile/frame-13/bubbles.png": 99285,
	"./comics-1/mobile/frame-14/bubbles.png": 43900,
	"./comics-1/mobile/frame-4/bubbles.png": 86694,
	"./comics-1/mobile/frame-5/bubbles.png": 23869,
	"./comics-1/mobile/frame-6/bubbles.png": 60080,
	"./comics-1/mobile/frame-7/bubbles.png": 26208,
	"./comics-1/mobile/frame-8/bubbles.png": 16239,
	"./comics-1/mobile/frame-9/bubbles.png": 84647,
	"./comics-10/desktop/frame-1/bubbles.png": 93411,
	"./comics-10/desktop/frame-2/bubbles.png": 77344,
	"./comics-10/mobile/frame-1/bubbles.png": 55814,
	"./comics-10/mobile/frame-2/bubbles.png": 71058,
	"./comics-11/desktop/frame-1/bubbles.png": 94656,
	"./comics-11/desktop/frame-3/bubbles.png": 89771,
	"./comics-11/desktop/frame-4/bubbles.png": 98359,
	"./comics-11/mobile/frame-1/bubbles.png": 26757,
	"./comics-11/mobile/frame-3/bubbles.png": 52457,
	"./comics-11/mobile/frame-4/bubbles.png": 84764,
	"./comics-12/desktop/frame-2/bubbles.png": 16500,
	"./comics-12/desktop/frame-3/bubbles.png": 99910,
	"./comics-12/desktop/frame-4/bubbles.png": 56288,
	"./comics-12/desktop/frame-5/bubbles.png": 55253,
	"./comics-12/mobile/frame-2/bubbles.png": 90895,
	"./comics-12/mobile/frame-3/bubbles.png": 19012,
	"./comics-12/mobile/frame-4/bubbles.png": 88408,
	"./comics-12/mobile/frame-5/bubbles.png": 5542,
	"./comics-2/desktop/frame-1/bubbles.png": 63504,
	"./comics-2/desktop/frame-2/bubbles.png": 57053,
	"./comics-2/mobile/frame-1/bubbles.png": 76467,
	"./comics-2/mobile/frame-2/bubbles.png": 81853,
	"./comics-3/desktop/frame-1/bubbles.png": 10490,
	"./comics-3/mobile/frame-1/bubbles.png": 92872,
	"./comics-4/desktop/frame-2/bubbles.png": 38008,
	"./comics-4/desktop/frame-3/bubbles.png": 69761,
	"./comics-4/desktop/frame-4/bubbles.png": 53326,
	"./comics-4/desktop/frame-5/bubbles.png": 12583,
	"./comics-4/mobile/frame-2/bubbles.png": 21555,
	"./comics-4/mobile/frame-3/bubbles.png": 68696,
	"./comics-4/mobile/frame-4/bubbles.png": 950,
	"./comics-4/mobile/frame-5/bubbles.png": 82613,
	"./comics-5/desktop/frame-1/bubbles.png": 42732,
	"./comics-5/desktop/frame-2/bubbles.png": 47586,
	"./comics-5/desktop/frame-3/bubbles.png": 58790,
	"./comics-5/desktop/frame-4/bubbles.png": 22091,
	"./comics-5/desktop/frame-5/bubbles.png": 73445,
	"./comics-5/desktop/frame-6/bubbles.png": 889,
	"./comics-5/desktop/frame-7/bubbles.png": 34954,
	"./comics-5/desktop/frame-8/bubbles.png": 11465,
	"./comics-5/mobile/frame-1/bubbles.png": 64211,
	"./comics-5/mobile/frame-2/bubbles.png": 66643,
	"./comics-5/mobile/frame-3/bubbles.png": 65799,
	"./comics-5/mobile/frame-4/bubbles.png": 19420,
	"./comics-5/mobile/frame-5/bubbles.png": 84617,
	"./comics-5/mobile/frame-6/bubbles.png": 40255,
	"./comics-5/mobile/frame-7/bubbles.png": 27109,
	"./comics-5/mobile/frame-8/bubbles.png": 65770,
	"./comics-6/desktop/frame-1/bubbles.png": 44639,
	"./comics-6/desktop/frame-2/bubbles.png": 67735,
	"./comics-6/mobile/frame-1/bubbles.png": 590,
	"./comics-6/mobile/frame-2/bubbles.png": 27781,
	"./comics-7/desktop/frame-1/bubbles.png": 41297,
	"./comics-7/desktop/frame-3/bubbles.png": 34721,
	"./comics-7/desktop/frame-4/bubbles.png": 22356,
	"./comics-7/mobile/frame-1/bubbles.png": 52178,
	"./comics-7/mobile/frame-3/bubbles.png": 40854,
	"./comics-7/mobile/frame-4/bubbles.png": 42291,
	"./comics-8/desktop/frame-2/bubbles.png": 94214,
	"./comics-8/desktop/frame-3/bubbles.png": 49791,
	"./comics-8/desktop/frame-4/bubbles.png": 59955,
	"./comics-8/desktop/frame-5/bubbles.png": 63625,
	"./comics-8/mobile/frame-2/bubbles.png": 98085,
	"./comics-8/mobile/frame-3/bubbles.png": 3984,
	"./comics-8/mobile/frame-4/bubbles.png": 92718,
	"./comics-8/mobile/frame-5/bubbles.png": 11766,
	"./comics-9/desktop/frame-3/bubbles.png": 33139,
	"./comics-9/desktop/frame-4/bubbles.png": 39811,
	"./comics-9/desktop/frame-5/bubbles.png": 38721,
	"./comics-9/desktop/frame-6/bubbles.png": 93966,
	"./comics-9/desktop/frame-7/bubbles.png": 52025,
	"./comics-9/desktop/frame-8/bubbles.png": 42391,
	"./comics-9/desktop/frame-9/bubbles.png": 2004,
	"./comics-9/mobile/frame-3/bubbles.png": 6304,
	"./comics-9/mobile/frame-4/bubbles.png": 92257,
	"./comics-9/mobile/frame-5/bubbles.png": 23371,
	"./comics-9/mobile/frame-6/bubbles.png": 58967,
	"./comics-9/mobile/frame-7/bubbles.png": 25215,
	"./comics-9/mobile/frame-8/bubbles.png": 96647,
	"./comics-9/mobile/frame-9/bubbles.png": 41566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58356;